export default "__VITE_ASSET__DnIy__Fi__"